import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.unit.simplebatchadd;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_UNIT_ASYNC: `${uid}.saveUnitAsync`,
    SAVE_UNIT_SUCCESS: `${uid}.saveUnitSuccess`,
    SAVE_UNIT_FAILURE: `${uid}.saveUnitFailure`,
    SAVE_UNIT_SILENT_ASYNC: `${uid}.saveUnitSilentAsync`,
    SAVE_UNIT_SILENT_SUCCESS: `${uid}.saveUnitSilentSuccess`,
    SAVE_UNIT_SILENT_FAILURE: `${uid}.saveUnitSilentFailure`,
    DELETE_UNIT_ASYNC: `${uid}.deleteUnitAsync`,
    DELETE_UNIT_SUCCESS: `${uid}.deleteUnitSuccess`,
    DELETE_UNIT_FAILURE: `${uid}.deleteUnitFailure`,
    REORDER_ASYNC: `${uid}.reorderAsync`,
    REORDER_SUCCESS: `${uid}.reorderSuccess`,
    REORDER_FAILURE: `${uid}.reorderFailure`,
    CHANGE_TITLE_ASYNC: `${uid}.changeTitleAsync`,
    CHANGE_TITLE_SUCCESS: `${uid}.changeTitleSuccess`,
    CHANGE_TITLE_FAILURE: `${uid}.changeTitleFailure`,
    BATCH_ADD_UNIT_ASYNC: `${uid}.batchAddUnitAsync`,
    BATCH_ADD_UNIT_SUCCESS: `${uid}.batchAddUnitSuccess`,
    BATCH_ADD_UNIT_FAILURE: `${uid}.batchAddUnitFailure`,
    BATCHADD_AND_CREATE_UNIT_ASYNC: `${uid}.batchAddAndCreateUnitAsync`,
    BATCHADD_AND_CREATE_UNIT_SUCCESS: `${uid}.batchAddAndCreateUnitSuccess`,
    BATCHADD_AND_CREATE_UNIT_FAILURE: `${uid}.batchAddAndCreateUnitFailure`,
    SELECT_UNIT_TYPE: `${uid}.selectUnitType`,
    ADD_UNIT: `${uid}.addUnit`,
    SHOW_ADD_SUBUNIT: `${uid}.showAddSubUnit`,
    ADD_SUBUNIT: `${uid}.addSubUnit`,
    MOVE_UNIT: `${uid}.moveUnit`,
    UPDATE_UNIT: `${uid}.updateUnit`,
    EDIT_UNIT: `${uid}.editUnit`,
    CANCEL_EDIT: `${uid}.cancelEdit`,
    CHANGE_UNIT_TYPE: `${uid}.changeUnitType`,
    DELETE_UNIT: `${uid}.deleteUnit`,
    DELETE_ALL_UNITS: `${uid}.deleteAllUnits`,
    SHOW_ERROR_UNITS: `${uid}.showErrorUnits`,
    RECREATE: `${uid}.recreate`,
};

export { ActionTypes };
